module.exports = new __parcel__URL__("lune-voile-pluie-2.1605b873.svg").toString();